export const setLoginSuccessUserDetails = (params) => {
    return {
        type: 'SetUserDetails',
        payload: params,
    };
};

export const setTennantName = (params) => {
    return {
        type: 'SetTennantName',
        payload: params,
    };
};

export const setPolicy = (params) => {
    return {
        type: 'SetPolicy',
        payload: params,
    };
};

